const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/kompendiumActions.ts';
import { KISAPI as API } from '../middleware/kisapi';
import { IKISAPIAction, IKISAPIMeta, kisapiActionTypes } from '../defs/actionTypes';
import { apiLoadKompendiumParagraphs } from '@cistec/common_web/actions/kisapi/medi';

export const LOAD_KOMPENDIUM_PARAGRAPHS = kisapiActionTypes('LOAD_KOMPENDIUM_PARAGRAPHS');

export interface ILoadKompendiumParagraphsMeta extends IKISAPIMeta {
    kompKey: string;
    showDlgWhenResultHasMoreRows: boolean;
}

export interface ILoadKompendiumParagraphsAction extends IKISAPIAction {
    meta: ILoadKompendiumParagraphsMeta;
}

/**
 * Loads the Kompendium (DocuMed) paragraphs belonging to the given kompKey.
 */
export function loadKompendiumParagraphs(kompKey: string) {
    const meta: ILoadKompendiumParagraphsMeta = {
        kompKey,
        showDlgWhenResultHasMoreRows: true,
    };
    return {
        type: LOAD_KOMPENDIUM_PARAGRAPHS.combined,
        [API]: apiLoadKompendiumParagraphs(kompKey),
        meta,
    };
}
